import { DataResult } from '../../utils/DataResult';
import { BillingValidationOptions, BillingValidationResult } from '../api';
import {
  BaseApiService,
  readJsonSafely,
  toMessages,
  toRequestError,
} from './http';

interface FcApiValidationPayload {
  detail?: { errors?: unknown; warnings?: unknown };
}

interface FcApiErrorEnvelope {
  errors?: unknown;
  warnings?: unknown;
}

/**
 * Handles billing information validation against the FCApi integration.
 */
export class BillingService extends BaseApiService {
  async validateBillingInformation({
    plant,
    costCenter,
    co,
    signal,
  }: BillingValidationOptions): Promise<BillingValidationResult> {
    const baseUrl = await this.getBaseUrl();

    const response = await this.fetchApi.fetch(`${baseUrl}/FCApi/validate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: { plant, costCenter, co } }),
      signal,
    });

    const body = await readJsonSafely(response);

    if (!response.ok) {
      const errors = toMessages((body as FcApiErrorEnvelope | null)?.errors);
      const warnings = toMessages(
        (body as FcApiErrorEnvelope | null)?.warnings,
      );

      if (errors.length === 0 && warnings.length === 0) {
        throw await toRequestError(response);
      }

      return { errors, warnings };
    }

    const detail = (body as DataResult<FcApiValidationPayload> | null)?.data
      ?.detail;

    return {
      errors: toMessages(detail?.errors),
      warnings: toMessages(detail?.warnings),
    };
  }
}
